import Template from './Template';
import { HeadProvider } from './context';

export { HeadProvider };
export default Template;
